import React from "react";
import { Seo } from "@/components/Seo";
import { ContactBlock } from "@/components/ContactBlock";
import { useContent } from "@/lib/api";

export default function BriefPage() {
  const { data } = useContent();
  const s = data?.settings || {};
  if (!data) return null;
  return (
    <main style={{ paddingTop: 96 }} data-testid="brief-page">
      <Seo
        title="Déposer un brief — proposition sans engagement | SLIZ"
        description="Dites l'objectif et le budget. SLIZ répond sous 24 h ouvrées, y compris quand ce n'est pas le moment de diffuser."
        path="/brief/"
      />
      <h1 className="t-h1 wrap" style={{ marginBottom: 0 }} data-testid="brief-h1">
        Votre brief, notre proposition sans engagement
      </h1>
      <ContactBlock contactSec={s.contactSec} />
    </main>
  );
}
